function HeroCanvas() {
  return (
    <svg
      viewBox="0 0 1440 900"
      preserveAspectRatio="xMidYMax slice"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="wg1" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#00d4c8" stopOpacity=".5" />
          <stop offset="100%" stopColor="#00d4c8" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="wg2" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#0066cc" stopOpacity=".35" />
          <stop offset="100%" stopColor="#0066cc" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path
        d="M0,700 C200,640 400,580 600,620 C800,660 1000,560 1200,580 C1300,590 1380,610 1440,600 L1440,900 L0,900 Z"
        fill="url(#wg1)"
        opacity=".4"
      />
      <path
        d="M0,760 C240,710 480,670 720,700 C960,730 1100,650 1440,668 L1440,900 L0,900 Z"
        fill="url(#wg1)"
        opacity=".22"
      />
      <path
        d="M0,830 C300,790 600,775 900,800 C1100,815 1280,790 1440,800 L1440,900 L0,900 Z"
        fill="url(#wg2)"
        opacity=".18"
      />
      <line x1="0" y1="0" x2="1440" y2="900" stroke="#00d4c8" strokeWidth=".3" opacity=".07" />
      <line x1="1440" y1="0" x2="0" y2="900" stroke="#00d4c8" strokeWidth=".3" opacity=".07" />
      <line x1="720" y1="0" x2="720" y2="900" stroke="#00d4c8" strokeWidth=".3" opacity=".05" />
      <line x1="0" y1="450" x2="1440" y2="450" stroke="#00d4c8" strokeWidth=".3" opacity=".05" />
      <polygon
        points="720,100 880,380 560,380"
        fill="none"
        stroke="#00d4c8"
        strokeWidth=".8"
        opacity=".1"
      />
      <polygon
        points="720,140 840,360 600,360"
        fill="none"
        stroke="#00d4c8"
        strokeWidth=".4"
        opacity=".06"
      />
    </svg>
  );
}

export default HeroCanvas;
